import React, { Component } from 'react';
import { Container, Row, Col, Button, Navbar, Image } from 'react-bootstrap';
import { IRootState } from '../../interfaces';
import { Dispatch } from 'redux';
import { viewHomePageRequest } from '../../action';
import { connect } from 'react-redux';
import { AppRoutes } from './../../config';
import AuthModal from '../../pages/Auth';
import Footer from './../../layout/main/Footer';
import { FrontendUrl } from "../../config";
import logo from '../../assets/images/logo.png';
class Home extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      posTop: 0,
      posTopJoin: 0,
      showLogin: true,
    };
  }



  componentDidMount = async () => {
    const rememberMe = localStorage.getItem('rememberMe') === 'true';
    const email = rememberMe ? localStorage.getItem('email') || '' : '';
    const password = rememberMe ? localStorage.getItem('password') || '' : '';
    this.setState({ email, password, rememberMe });
    ;
    if (localStorage.getItem("userToken")) {
      this.props.history.push(AppRoutes.MY_VIDEOS);
    } else {
      this.props.history.push("/");
    }
  };

  handleScrollToFeature = (e: any, type: string) => {
    const { posTop, posTopJoin } = this.state;
    window.scroll({
      top: type === 'howitworks' ? posTop : posTopJoin,
      behavior: 'smooth',
    });
  };

  render() {
    const { show, modalLabel } = this.state;
    const { homePageReducer } = this.props;
    const { homePageInfo } = homePageReducer;


    return (
      <>
        <div className="header-logo">
          <Navbar.Brand className='sticky-logo cursor-pointer'>
              <Image
                    src={logo}
                    className="header-img"
                  />
          </Navbar.Brand>
        </div>
        <Col lg={12} md={6} sm={12} className="home-col">
          <AuthModal
            {...this.props}>
          </AuthModal>
        </Col>
        <Footer    {...this.props} />
      </>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  homePageReducer: state.homePageReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    viewHomePage: () => {
      dispatch(viewHomePageRequest());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home);
